import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const DocumentOutlined = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function DocumentOutlined({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <g fill="currentColor">
          <path d="M15.5 6h-8v2h8V6ZM11.5 10h-4v2h4v-2Z" />
          <path fillRule="evenodd" clipRule="evenodd" d="M3 23V1h18v22H3Zm16-2H5V3h14v18Z" />
        </g>
      </svg>;
}) as ForwardedIconComponent);
export default DocumentOutlined;